export class TranslationTextDetailView {
    public no: number;
    public mediaId: string;
    public mediaContentId: string;
    public mediaName: string;
    public mediaTypeCode: string
    public languageCode: string;
    public languageName: string;
    public text: string;
}